export default __webpack_public_path__ + "static/media/029-scale.9182e3bf.svg";